export const SET_LOADING = "SET_LOADING";
//export const SET_ACTIVESTEP = "SET_ACTIVESTEP";
export const SET_VALUE = "SET_VALUE";
export const SET_USER_INPUT_STATE = "SET_USER_INPUT_STATE";
export const SET_HUBSPOT_CONTACT = "SET_HUBSPOT_CONTACT";
